<mat-form-field class="custom-multi-select">
    <mat-label>{{label}}</mat-label>
    <mat-select class="custom-multi-select-field" multiple [(ngModel)]="selectedValue" (ngModelChange)="valueChange()" [disabled]="disabled">
        <mat-option *ngFor="let item of filterItems" 
            [value]="item.id"
            [disabled]="item.disabled || disabled"
            [selected]="item.selected"
            >{{item.name}}</mat-option>
    </mat-select>
</mat-form-field>